import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';
// `eager`: título do manifesto no ⌘K e no breadcrumb antes de a tela abrir (A07).
registerModuleCatalog('credit-product', (locale: Locale) => import(`./locales/${locale}.po`), {
  eager: true,
});
export const loadCreditProductMessages = () => ensureModuleMessages('credit-product');
